export default __webpack_public_path__ + "static/media/flask.8bee818e.svg";